import React, { useState, useEffect } from 'react';
import { FiAlertTriangle, FiX } from 'react-icons/fi';
import { useUser } from '../../context/UserContext';

export default function PayrollBanner() {
  const { user } = useUser();
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    // Check if user is staff or clinician
    if (!user || user.role === 'admin') {
      return;
    }

    // Check if it's the final week of the month (24th to 31st)
    const today = new Date();
    const dayOfMonth = today.getDate();
    const isLastWeek = dayOfMonth >= 24;

    // Check if banner was dismissed this session
    const sessionKey = `payroll-banner-dismissed-${today.getFullYear()}-${today.getMonth()}`;
    const wasDismissed = sessionStorage.getItem(sessionKey) === 'true';

    setIsVisible(isLastWeek && !wasDismissed);
    setIsDismissed(wasDismissed);
  }, [user]);

  const handleDismiss = () => {
    const today = new Date();
    const sessionKey = `payroll-banner-dismissed-${today.getFullYear()}-${today.getMonth()}`;
    sessionStorage.setItem(sessionKey, 'true');
    setIsVisible(false);
    setIsDismissed(true);
  };

  if (!isVisible || isDismissed) {
    return null;
  }

  return (
    <div className="bg-orange-50 border-l-4 border-orange-400 p-4 mb-6 rounded-r-lg shadow-sm">
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <FiAlertTriangle className="h-5 w-5 text-orange-400" />
        </div>
        <div className="ml-3 flex-1">
          <p className="text-sm text-orange-800">
            <strong>Payroll Reminder:</strong> Please ensure all completed appointments are marked as 
            <strong> Attended</strong> before the end of the month to ensure accurate wage calculation.
          </p>
        </div>
        <div className="ml-auto pl-3">
          <div className="-mx-1.5 -my-1.5">
            <button
              onClick={handleDismiss}
              className="inline-flex rounded-md p-1.5 text-orange-500 hover:bg-orange-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-orange-50 focus:ring-orange-600"
            >
              <span className="sr-only">Dismiss</span>
              <FiX className="h-5 w-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
